"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const steps = [{
  number: "1",
  title: "Skicka din offertförfrågan",
  description: "Beskriv dina önskemål och förutsättningar i formuläret ovan, eller kontakta oss på info@proffsbadrum.se. Vi går igenom underlaget och återkommer för att ta nästa steg i din badrumsrenovering."
}, {
  number: "2",
  title: "Design och planering",
  description: "Vi går igenom projektets förutsättningar tillsammans med dig och planerar badrummet utifrån dina önskemål, funktion och materialval."
}, {
  number: "3",
  title: "Renovering & installation",
  description: "När planeringen är klar samordnas arbetet och badrumsrenoveringen genomförs enligt överenskommen omfattning och planering."
}, {
  number: "4",
  title: "Kontroll och färdigställande",
  description: "När arbetet är färdigt går vi igenom badrummet och kontrollerar utförandet innan projektet avslutas."
}];
export default function OurProcess() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="174596" id="formulär" className="bg-background py-24 md:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {}
        <div className="text-center max-w-3xl mx-auto mb-16 md:mb-24">
          <h2 className="font-default text-4xl md:text-5xl font-bold text-foreground mb-6">Från offertförfrågan till färdigt badrum i Värmland</h2>
          <div className="h-1 w-24 bg-primary mx-auto rounded-full opacity-80" />
        </div>

        {}
        <div ref={ref} className={`relative transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {}
          <div className="hidden md:block absolute top-12 left-[12.5%] right-[12.5%] h-[2px] border-t-2 border-dotted border-primary/40 z-0" />
          
          {}
          <div className="md:hidden absolute top-12 bottom-12 left-1/2 -translate-x-1/2 w-[2px] border-l-2 border-dotted border-primary/40 z-0" />

          <div className="flex flex-col md:flex-row justify-between gap-12 md:gap-6 relative z-10">
            {steps.map((step, i) => <div key={i} data-index={i} className="flex-1 flex flex-col items-center text-center group">
                {}
                <div className="size-24 rounded-full border-[1.5px] border-primary bg-background text-primary flex items-center justify-center mb-6 md:mb-8 shadow-sm transition-transform duration-500 group-hover:scale-110 group-hover:shadow-md relative">
                  <span className="font-default text-4xl font-light tracking-tighter">
                    {step.number}
                  </span>
                  {}
                  <div className="absolute inset-0 rounded-full bg-primary/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                </div>

                {}
                <div className="px-2">
                  <h3 className="font-default font-bold text-xl text-foreground mb-4">
                    {step.title}
                  </h3>
                  <p className="font-default text-foreground/80 leading-relaxed text-sm md:text-base max-w-[280px] mx-auto">
                    {step.description}
                  </p>
                </div>
              </div>)}
          </div>
        </div>

      </div>
    </section>;
}